export default "__VITE_ASSET__B1htI$50__"